import React, { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../../../App/Hooks/reduxHooks'
import { TextArea } from '../../../../Common/TextInput'
import { updateAppointmentNotes } from '../../../store/thunks/updateApointmentNotes'
import { IRepeatDetails } from '../../../types'

import { UpdateRepeatMessage } from './UpdateRepeatMessage'

interface IProps {
  repeatDetails: IRepeatDetails | null
  appointmentDateKey: string
  appointmentNotes: string
  appointmentUuid: string
}

export const UpdateNotes: FunctionComponent<IProps> = ({
  repeatDetails,
  appointmentDateKey,
  appointmentNotes,
  appointmentUuid,
}) => {
  const [notes, setNotes] = useState<string>(appointmentNotes)
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const blurHandler = () => {
    dispatch(
      updateAppointmentNotes({
        appointmentNote: notes,
        appointmentUuid,
        appointmentDateKey,
      }),
    )
  }

  return (
    <div>
      <UpdateRepeatMessage repeatDetails={repeatDetails} />
      <label htmlFor="notes">
        <span>{t('Appointment note')}</span>
        <TextArea
          onChange={text => setNotes(text.target.value)}
          value={notes}
          width={400}
          onBlur={blurHandler}
        />
      </label>
    </div>
  )
}
